import { ContextSnackbar } from "contexts/ContextSnackbar";
import { useContext } from "react";

const useSnackbar = () => useContext(ContextSnackbar);

export default useSnackbar;
